import { defineComponent as _defineComponent } from 'vue'
import dayjs from 'dayjs';
import DownloadFileIcon from '@/assets/images/svg/download-file.svg?component';
import TrashcanIcon from '@/assets/images/svg/trashcan.svg?component';
import LinkIcon from '@/assets/images/svg/link.svg?component';
import CheckIcon from '@/assets/images/svg/check.svg?component';
import HideEyeIcon from '@/assets/images/svg/hide-eye.svg?component';
import ShowEyeIcon from '@/assets/images/svg/show-eye.svg?component';
import ReportActionButton from '@/_core/entities/report/ui/ReportActionButton/ReportActionButton.vue';
import { TReport } from '../../models/types';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportGeneralDetails',
  props: {
    reportData: null,
    isSingleScan: { type: Boolean },
    isDownloading: { type: Boolean },
    isTogglingShared: { type: Boolean }
  },
  emits: ["download", "toggleShared"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'download'): void;
  (e: 'toggleShared', shared: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  reportData: TReport;
  isSingleScan: boolean;
  isDownloading: boolean;
  isTogglingShared: boolean;
};





const scanCompletionDateTime = computed(() => {
  if (props.reportData?.completionTime) {
    return dayjs(props.reportData.completionTime).format('DD MMM YYYY [at] HH:mm');
  }

  return 'N/A';
});

const isCopied = ref(false);

async function copyLink() {
  await navigator.clipboard.writeText(window.location.href);
  isCopied.value = true;
  setTimeout(() => (isCopied.value = false), 2000);
}

return { __sfc: true,props, emit, scanCompletionDateTime, isCopied, copyLink, DownloadFileIcon, TrashcanIcon, LinkIcon, CheckIcon, HideEyeIcon, ShowEyeIcon, ReportActionButton }
}

})